export const JOB_NOTES_LOADED = "JOB_NOTES_LOADED";
export const MATCH_NOTES_LOADED = "MATCH_NOTES_LOADED";
export const USER_NOTES_LOADED = "USER_NOTES_LOADED";
